import Coupons from "@/views/coupons/Coupons";

export default [
    {
        path: '/coupons',
        component: Coupons,
    },
]